export { getTextHeight, getTextWidth } from './MeasureText';